import { FormGroup, Text } from '@ksyos/design-system';
import type { IEmbloomQuestionnaire } from '../../../../interfaces/embloomQuestionnaire';
import { translateKey } from '../../../../../translate';

export interface IEmbloomQuestionnairesFormSectionReadProps {
    decisionSupportEmbloomQuestionnaires: { embloomQuestionnaire: IEmbloomQuestionnaire }[];
    nonDecisionSupportEmbloomQuestionnaires: { embloomQuestionnaire: IEmbloomQuestionnaire }[];
}

export function EmbloomQuestionnairesFormSectionRead(props: IEmbloomQuestionnairesFormSectionReadProps) {
    return (
        <>
            {props.decisionSupportEmbloomQuestionnaires.length > 0 && (
                <FormGroup label={translateKey('embloomQuestionnaires.isDecisionSupport')}>
                    {props.decisionSupportEmbloomQuestionnaires.map((item, key) => (
                        <Text
                            fontWeight="medium"
                            key={key}
                            mb={4}
                        >
                            {item.embloomQuestionnaire.label}{' '}
                            {item.embloomQuestionnaire.description ? (
                                <span> - {item.embloomQuestionnaire.description}</span>
                            ) : null}
                        </Text>
                    ))}
                </FormGroup>
            )}

            {props.nonDecisionSupportEmbloomQuestionnaires.length > 0 && (
                <FormGroup label={translateKey('embloomQuestionnaires.otherQuestionnaires')}>
                    {props.nonDecisionSupportEmbloomQuestionnaires.map((item, key) => (
                        <Text
                            fontWeight="medium"
                            key={key}
                            mb={4}
                        >
                            {item.embloomQuestionnaire.label}{' '}
                            {item.embloomQuestionnaire.description ? (
                                <span> - {item.embloomQuestionnaire.description}</span>
                            ) : null}
                        </Text>
                    ))}
                </FormGroup>
            )}
        </>
    );
}
